import { Link } from "react-router-dom";
import { characters } from "@/mocks/characters";
import SectionHeading from "@/components/base/SectionHeading";

const QUICK_LINKS = [
  { label: "剧集剧情", desc: "主线与支线深度解析", to: "/category/drama", icon: "ri-book-open-line" },
  { label: "角色介绍", desc: "人物关系与背景档案", to: "/category/characters", icon: "ri-user-3-line" },
  { label: "影视资讯", desc: "最新动态与幕后花絮", to: "/category/news", icon: "ri-newspaper-line" },
];

export default function CharacterSidebar() {
  const items = characters.slice(0, 4);

  return (
    <div className="flex flex-col gap-8">
      <section>
        <SectionHeading eyebrow="Cast" title="角色快速导览" moreTo="/category/characters" />
        <div className="grid grid-cols-2 gap-3">
          {items.map((character) => (
            <Link
              key={character.id}
              to={`/detail/${character.id}`}
              className="group overflow-hidden rounded-lg border border-background-200 bg-background-50 transition-colors hover:border-primary-300"
            >
              <div className="h-40 w-full overflow-hidden bg-background-200">
                <img
                  src={character.avatar}
                  alt={character.name}
                  title={`${character.name} - 我妻子的一切角色`}
                  className="h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
                />
              </div>
              <div className="p-3">
                <div className="flex items-center justify-between gap-2">
                  <p className="font-heading text-sm font-semibold text-foreground-950 transition-colors group-hover:text-primary-700">
                    {character.name}
                  </p>
                  <span className="shrink-0 rounded bg-accent-100 px-1.5 py-0.5 text-[10px] text-accent-900">
                    {character.role}
                  </span>
                </div>
                <p className="mt-1 truncate text-xs text-foreground-500">{character.position}</p>
              </div>
            </Link>
          ))}
        </div>
      </section>

      <section className="rounded-lg bg-primary-900 p-5">
        <p className="text-xs font-medium uppercase tracking-[0.2em] text-accent-400">Quick Access</p>
        <h3 className="mt-1.5 font-heading text-lg font-semibold text-background-50">剧集快捷入口</h3>
        <div className="mt-4 flex flex-col gap-2">
          {QUICK_LINKS.map((link) => (
            <Link
              key={link.to}
              to={link.to}
              className="group flex items-center gap-3 rounded-md bg-primary-950/50 px-3 py-3 transition-colors hover:bg-primary-950/80"
            >
              <span className="flex h-9 w-9 shrink-0 items-center justify-center rounded-md bg-accent-500/15 text-accent-400">
                <i className={`${link.icon} text-lg`} />
              </span>
              <span className="min-w-0 flex-1">
                <span className="block text-sm font-medium text-background-50">{link.label}</span>
                <span className="block truncate text-xs text-background-400">{link.desc}</span>
              </span>
              <i className="ri-arrow-right-s-line text-background-400 transition-transform group-hover:translate-x-0.5" />
            </Link>
          ))}
        </div>
      </section>
    </div>
  );
}